/**
 * Token lists for canonical vehicle title sanitization (M1).
 * Keep aligned with server/vehicleIntelligence/vehicleIdentity/canonicalVehicleTitleConstants.js
 */

/** Standalone equipment / marketing descriptors removable from model text. */
export const REMOVABLE_EQUIPMENT_TOKENS = [
  "FULL EQUIPO",
  "EDICIÓN ESPECIAL",
  "EDICION ESPECIAL",
  "BOSE",
  "FULL",
  "ABS",
  "MODELO",
  "MODEL",
];

/** Transmission tokens removed only as standalone words (word-boundary matched). */
export const TRANSMISSION_TOKENS = [
  "AUTOMÁTICA",
  "AUTOMATICA",
  "AUTOMÁTICO",
  "AUTOMATICO",
  "AUTOMATIC",
  "MECÁNICA",
  "MECANICA",
  "MANUAL",
  "TIPTRONIC",
  "CVT",
  "DSG",
  "A/T",
  "M/T",
  "AT",
  "MT",
];

/** Fuel / drivetrain tokens removed as standalone words from model text. */
export const FUEL_TYPE_TOKENS = [
  "HÍBRIDO",
  "HIBRIDO",
  "HÍBRIDA",
  "HIBRIDA",
  "GASOLINA",
  "DIESEL",
  "ELÉCTRICO",
  "ELECTRICO",
  "ELÉCTRICA",
  "ELECTRICA",
  "GAS",
  "GNV",
  "GLP",
  "ENCHUFABLE",
];

/** Multi-word fuel descriptors removed from trim/model identity fields. */
export const FUEL_TYPE_PHRASES = [
  "HÍBRIDO ENCHUFABLE",
  "HIBRIDO ENCHUFABLE",
  "HYBRID PLUG IN",
  "PLUG IN HYBRID",
  "PLUGIN HYBRID",
  "PLUG-IN HYBRID",
];

/** Mileage unit tokens with no identity value when trim/model is otherwise empty. */
export const MILEAGE_UNIT_TOKENS = ["KM", "KMS", "KILÓMETROS", "KILOMETROS", "KILOMETRAJE"];

/** Color names that are not trim identity when they appear alone. */
export const COLOR_ONLY_TOKENS = [
  "BLANCO",
  "NEGRO",
  "ROJO",
  "AZUL",
  "GRIS",
  "PLATA",
  "VERDE",
  "AMARILLO",
  "BEIGE",
  "CAFE",
  "CAFÉ",
  "MARRON",
  "MARRÓN",
  "DORADO",
  "PERLA",
  "NARANJA",
  "VINO",
  "TINTO",
];

/** Fuel / drivetrain suffixes removed conservatively when trailing non-identity noise. */
export const TRAILING_POLLUTION_TOKENS = [
  "GASOLINA",
  "DIESEL",
  "HÍBRIDO",
  "HIBRIDO",
  "HIBRIDA",
  "HÍBRIDA",
  "4X2",
  "4X4",
  "AWD",
  "FWD",
  "RWD",
  "TURBO",
];

/**
 * Display casing preserved for known automotive tokens (uppercase key → display form).
 */
export const PRESERVED_DISPLAY_TOKENS = Object.freeze({
  BMW: "BMW",
  BYD: "BYD",
  DS: "DS",
  MG: "MG",
  GTI: "GTI",
  AMG: "AMG",
  "CR-V": "CR-V",
  "CX-5": "CX-5",
  "CX-3": "CX-3",
  "CX-30": "CX-30",
  "CX-9": "CX-9",
  "F-150": "F-150",
  F150: "F-150",
  IX: "iX",
  "E-TRON": "e-tron",
  M3: "M3",
  M5: "M5",
  X1: "X1",
  X3: "X3",
  X5: "X5",
  Q5: "Q5",
  Q3: "Q3",
  Q7: "Q7",
  A4: "A4",
  A3: "A3",
});
